import * as React from 'react';
import {useJsonForms, withJsonFormsControlProps} from '@jsonforms/react';
import Content from "./Content";
import {SchemaUtils} from "../../util/SchemaUtils";

interface ContentControlProps {
    description?: any;
    schema: any;
    uischema: any;
}

const ContentControl = ({ schema, uischema }: ContentControlProps) => {

    const jsonForms = useJsonForms();

    let visible = SchemaUtils.isComponentVisible(uischema, jsonForms.core!.data);
    const value = visible ? schema.description : "";

    return (
        <Content
            description={value}
            visible={visible}
        />
    );
}

// @ts-ignore
export default withJsonFormsControlProps(ContentControl);
